export default "__VITE_ASSET__21df3bb1__"